import deviceMenu from '@js/common/deviceMenu.js';

deviceMenu();

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('[data-stack-list]')) {
		import('@js/modules/how-it-works.js').then(({ initHowItWorks }) => initHowItWorks());
	}

	if (document.querySelector('[data-tabs-container]')) {
		import('@js/modules/tabs.js').then(({ initPackagesTabs }) => initPackagesTabs());
	}
});
